import {
  createSignature
} from "@/utils/index";
//获取访问的设备信息
export const getDevice = () => {
  let u = navigator.userAgent,
    app = navigator.appVersion;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  let isIphoneX = /iPhoneX/.test(u);
  if (isiOS && screen.height == 812 && screen.width == 375) {
    return "iPhoneX"
  }
  if (isAndroid) {
    return "android";
  } else if (isIphoneX) {
    return "iPhoneX";
  } else if (isiOS) {
    return "ios";
  } else {
    return "web";
  }
};

// 	转义html标签
export const HtmlEncode = text => {
  text
    .replace(/&/g, "&")
    .replace(/\"/g, '"')
    .replace(/</g, "<")
    .replace(/>/g, ">");
};

// utf8解码
export const utf8_decode = str_data => {
  let tmp_arr = [],
    i = 0,
    ac = 0,
    c1 = 0,
    c2 = 0,
    c3 = 0;
  str_data += "";
  while (i < str_data.length) {
    c1 = str_data.charCodeAt(i);
    if (c1 < 128) {
      tmp_arr[ac++] = String.fromCharCode(c1);
      i++;
    } else if (c1 > 191 && c1 < 224) {
      c2 = str_data.charCodeAt(i + 1);
      tmp_arr[ac++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
      i += 2;
    } else {
      c2 = str_data.charCodeAt(i + 1);
      c3 = str_data.charCodeAt(i + 2);
      tmp_arr[ac++] = String.fromCharCode(
        ((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
      );
      i += 3;
    }
  }
  return tmp_arr.join("");
};

//query 获取地址栏参数
export const getQueryString = name => { //如：http://www.baidu.com/?tab=2  →  getQueryString('tab') →   2;
  let href = document.location.href;
  let string = href.substring(href.indexOf('?') + 1);
  let oArr = {};
  let arr = string.split('&');
  for (let i = 0; i < arr.length; i++) {
    let newArr = arr[i].split('=');
    oArr[newArr[0]] = newArr[1];
  }
  return oArr[name] ? decodeURIComponent(oArr[name]) : '';
}


//身份证脱敏
export const idCardTuo = (str) => {
  //console.log(idCardTuo('429004199409173672'));
  if (typeof str === 'string') {
    let ruten = str.substring(0, str.length - 4); //提取字符串下标之间的字符。
    let replace = '';
    for (let i = 0; i < ruten.length; i++) {
      replace += '*'
    }
    return str.replace(ruten, replace); //字符串中用字符替换另外字符，或替换一个与正则表达式匹配的子串。
  }
}


//手机号脱敏
export const phoneNumTuo = (str) => {
  if (typeof str === 'string') {
    let pat = /(\d{3})\d*(\d{4})/
    let phoneNum = str.replace(pat, '$1****$2');
    return phoneNum;
  }
}


//银行脱敏
export const bankTuo = (str) => {
  if (typeof str === 'string') {
    let ruten = str.substring(6, str.length - 4); //提取字符串下标之间的字符。
    let replace = '';
    for (let i = 0; i < ruten.length; i++) {
      replace += '*'
    }
    return str.replace(ruten, replace); //字符串中用字符替换另外字符，或替换一个与正则表达式匹配的子串。
  }

}

//判断是否微信客户端打开页面
export const isWeixin = () => {
  var ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf("micromessenger") != -1;
  if (!isWeixin) {
    return false;
  } else {
    return true;
  }
}

//判断是否Safari浏览器
export const isSafari = () => {
  var ua = navigator.userAgent.toLowerCase();
  var isSafari = ua.indexOf("safari") != -1 && ua.indexOf("version") != -1;
  if (isSafari) {
    return true
  } else {
    return false
  }
}

//判断是否登录
export const isLogin = () => {
  let storage_token = localStorage.getItem("app_token");
  let isBind = localStorage.getItem("isBind");
  var ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf("micromessenger") != -1;
  if (isWeixin && storage_token) {
    if (isBind == '1') {
      return true
    } else {
      return false
    }
  } else {
    return storage_token
  }
}


//客户端类型 clientType 0是大童咨询，1是童管家

export const clientType = () => {
  let clientType = localStorage.getItem("clientType");
  if (clientType) {
    return clientType
  } else {
    return '0'
  }
}

//判断是否绑定
export const isBind = () => {
  let isBind = sessionStorage.getItem("isBind");
  if (isBind) {
    if (isBind == '1') {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

/**
 * 获取元素的offset
 */
export const offset = (el) => {
  var left = 0
  var top = 0
  while (el) {
    left += el.offsetLeft
    top += el.offsetTop
    el = el.offsetParent
  }
  return {
    left: left,
    top: top,
    el: el
  }
}

/**
 * 元素滚动方法
 */
export const scrollToElement = function (el, delay = 20, rootEl = "wrap") {
  let wrapper = this.$refs[rootEl]
  if (!wrapper || !el) {
    return
  }
  let pos = offset(el)
  let wrapperOffset = offset(wrapper)
  pos.top -= wrapperOffset.top
  wrapper.scrollTop = pos.top
}

/**
 * 计算周岁
 * @param {String} date  format YYYY-MM-DD
 */
export const calculateAge = date => {
  let now = new Date()
  let birth = new Date(date)

  if ((birth.getTime() - now.getTime()) > 0) {
    return 0
  }

  let nowYear = now.getFullYear()
  let nowMonth = now.getMonth() + 1
  let nowDay = now.getDate()

  let birthYear = birth.getFullYear()
  let birthMonth = birth.getMonth() + 1
  let birthDay = birth.getDate()

  let age = nowYear - birthYear
  if (nowMonth <= birthMonth) {
    if (nowMonth == birthMonth) {
      if (nowDay < birthDay) {
        age--
      }
    } else {
      age--
    }
  }
  return age
};

/**
 * 通过毫秒获取格式化日期
 * @param ms 毫秒
 * @param type 日期类型 1：年 2：年月...
 * @returns {string}
 */
export const formartDate = (ms, type) => {
  if (typeof ms !== 'number') {
    return
  }
  let date = new Date(ms)
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  let hours = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`
  let min = date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`
  let sec = date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`

  switch (type) {
    case 1:
      return `${year}`;
    case 2:
      return `${year}/${month}`;
    case 3:
      return `${year}/${month}/${day}`;
    case 4:
      return `${year}/${month}/${day} ${hours}`
    case 5:
      return `${year}/${month}/${day} ${hours}:${min}`
    case 6:
      return `${year}/${month}/${day} ${hours}:${min}:${sec}`
    default:
      return `${year}/${month}/${day} ${hours}:${min}`
  }
}


export const uuid = (len, radix) => {
  var chars = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [],
    i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    // rfc4122, version 4 form
    var r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('');
}


export const isIdCardNo = (num) => {
  num = num.toUpperCase();
  //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。 
  // 2018-8-10 去除15身份证的校验
  // /(^\d{15}$)|(^\d{17}([0-9]|X)$)/

  if (!(/(^\d{17}([0-9]|X)$)/.test(num))) {
    return false;
  }
  //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
  //下面分别分析出生日期和校验位 
  var len, re;
  len = num.length;
  if (len == 15) {
    re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
    var arrSplit = num.match(re);
    //检查生日日期是否正确
    var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
    var bGoodDay;
    bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) &&
      ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) &&
      (dtmBirth.getDate() == Number(arrSplit[4]));
    if (!bGoodDay) {
      return false;
    } else {
      //将15位身份证转成18位 
      //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。          
      var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
      var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
      var nTemp = 0,
        i;
      num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
      for (i = 0; i < 17; i++) {
        nTemp += num.substr(i, 1) * arrInt[i];
      }
      num += arrCh[nTemp % 11];
      return num;
    }
  }
  if (len == 18) {
    re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
    var arrSplit = num.match(re);
    //检查生日日期是否正确 
    var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
    var bGoodDay;
    bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) &&
      ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) &&
      (dtmBirth.getDate() == Number(arrSplit[4]));
    if (!bGoodDay) {
      return false;
    } else {
      //检验18位身份证的校验码是否正确。 
      //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
      var valnum;
      var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
      var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
      var nTemp = 0,
        i;
      for (i = 0; i < 17; i++) {
        nTemp += num.substr(i, 1) * arrInt[i];
      }
      valnum = arrCh[nTemp % 11];
      if (valnum != num.substr(17, 1)) {
        return false;
      }
      return num;
    }
  }
  return false;
}


export const AppendJs = (callback) => {
  var scripts = ['https://player.polyv.net/script/polyvplayer.min.js'];
  var HEAD =
    document.getElementsByTagName("head").item(0) ||
    document.documentElement;
  var s = new Array(),
    last = scripts.length - 1,
    recursiveLoad = function (i) {
      //递归
      s[i] = document.createElement("script");
      s[i].setAttribute("type", "text/javascript");
      s[i].onload = s[i].onreadystatechange = function () {
        //Attach handlers for all browsers
        if (
          ! /*@cc_on!@*/ 0 ||
          this.readyState == "loaded" ||
          this.readyState == "complete"
        ) {
          this.onload = this.onreadystatechange = null;
          this.parentNode.removeChild(this);
          if (i != last) recursiveLoad(i + 1);
          else if (typeof callback == "function") {
            callback();
          }
        }
      };
      s[i].setAttribute("src", scripts[i]);
      HEAD.appendChild(s[i]);
    };
  recursiveLoad(0);
}


//微信分享

export const share = (shareData) => {
  if (getDevice() == "android") {
    createSignature();
  }
  wx.ready(() => {
    //需在用户可能点击分享按钮前就先调用
    if (wx.onMenuShareAppMessage) {
      //微信文档中提到这两个接口即将弃用，故判断
      wx.onMenuShareAppMessage(shareData, function (res) {
        //这里是回调函数
      }); //1.0 分享到朋友
      wx.onMenuShareTimeline(shareData, function (res) {
        //这里是回调函数
      }); //1.0分享到朋友圈
    } else {
      wx.updateAppMessageShareData(shareData); //1.4 分享到朋友
      wx.updateTimelineShareData(shareData); //1.4分享到朋友圈
    }
  });
}

//清除分享按钮

export const hideMenuItems = () => {
  if (getDevice() == "android") {
    createSignature();
  }
  wx.ready(() => {
    wx.hideMenuItems({
      menuList: [
        "menuItem:copyUrl",
        "menuItem:share:appMessage",
        "menuItem:share:timeline",
        "menuItem:share:qq",
        "menuItem:share:QZone"
      ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    });
  });
}



export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}


export function countTime(start, end) {
  let startTime = start.getTime()
  let endTime = end.getTime()
  let second = parseInt((endTime - startTime) / 1000);
  return second
}

/**
 *
 * 日期格式化
 */
export const formateDate = function (date, formate) {
	if (!date) {
		return '';
	}
	var date = new Date(date);
	var o = {
		'M+': date.getMonth() + 1, // 月份
		'd+': date.getDate(), // 日
		'[hH]+': date.getHours(), // 小时
		'm+': date.getMinutes(), // 分
		's+': date.getSeconds(), // 秒
		'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
		S: date.getMilliseconds(), // 毫秒
	};
	if (/(y+)/.test(formate)) {
		formate = formate.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp('(' + k + ')').test(formate)) {
			formate = formate.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
		}
	}
	return formate;
};




// WEBPACK FOOTER //
// ./src/config/utils.js